import React from 'react';

export const InformationIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path fill="#007AFF" fillRule="nonzero" d="M9.796 19.592C4.386 19.592 0 15.206 0 9.796 0 4.386 4.386 0 9.796 0c5.41 0 9.796 4.386 9.796 9.796 0 2.598-1.032 5.09-2.87 6.927-1.836 1.837-4.328 2.869-6.926 2.869z" />
      <path fill="#FFF" d="M10.408 6.53c-.731.052-1.368-.493-1.428-1.224.06-.73.697-1.276 1.428-1.224.731-.052 1.368.494 1.429 1.224-.06.73-.698 1.277-1.429 1.225zM10.988 9.291l-1.137 4.29c-.11.416.107.85.507 1.01.155.062.257.212.257.38v.131c0 .225-.183.408-.408.408h-1.22c-.381.002-.741-.173-.975-.474-.233-.301-.314-.693-.218-1.062l1.137-4.29c.11-.416-.107-.85-.507-1.01-.155-.062-.257-.212-.257-.379v-.132c0-.225.183-.408.408-.408h1.22c.381-.002.741.173.975.474.234.301.314.694.218 1.062z" />
    </g>
  </svg>
);
export default InformationIcon;
